<template>
    <div id="tabbar" role="tablist">
        <a v-for="(item,index) in tabberItem" class="tabbar-item" :key="index" @click="tabbarItem(item.path,index)" :aria-labelledby="['tab' + index]"  role="tab">
            <div class="home-icon" >
                <div>
                    <img :src="item.type ? item.imgOn : item.img" :alt="item.type ? '已选中' : '未选中'">
                </div>
            </div>
            <div class="home-text" :id="['tab' + index]" aria-hidden="true" :class="item.type? 'hover' : ''">{{item.name}}</div>
        </a>


<!--        <div v-if="hidden" class="wechat" @click="hiddenWechat()" aria-labelledby="erweima" role="dialog" tabindex="1">-->
<!--            <div>-->
<!--                <img id="erweima" :src="images" alt="微信二维码，长按扫码" >-->
<!--            </div>-->
<!--        </div>-->

            <div v-if="hidden" class="wechat" @click="hiddenWechat()" role="dialog" tabindex="1">
                <div>
                    <img id="erweima" :src="images" alt="微信二维码，长按扫码" >
                </div>
            </div>

<!--        <van-popup v-model="hidden">-->
<!--            <div class="erweima" role="dialog" tabindex="0" id="erweima">-->
<!--                <img :src="images" alt="微信二维码，长按扫码" >-->
<!--            </div>-->
<!--        </van-popup>-->
    </div>

</template>

<script>

    import Vue from 'vue';
    import {Field, Button, Notify, Icon, Popup} from 'vant';
    // icon
    import mokuai from '@/views/anshibao/icon/icon_mokuai.png';
    import mokuaiOn from '@/views/anshibao/icon/icon_mokuai_on.png';
    import tel from '@/views/anshibao/icon/icon_tel.png';
    import telOn from '@/views/anshibao/icon/icon_tel_on.png';
    import qq from '@/views/anshibao/icon/icon_qq.png';
    import qqOn from '@/views/anshibao/icon/icon_qq_on.png';
    import wechat from '@/views/anshibao/icon/icon_wechat.png';
    import wechatOn from '@/views/anshibao/icon/icon_wechat_on.png';
    import home from '@/views/anshibao/icon/icon_home.png';
    import weixin from '@/views/anshibao/icon/AhomeIcon/weixin.jpg';
    Vue.use(Field).use(Button).use(Notify);
    Vue.use(Icon);
    Vue.use(Popup);
    export default {
        data() {
            return {
                hidden: false,
                a : "1",
                tel: "010-86464262",
                tabberItem: [
                    {
                        path: "/AInsurancePolicy",
                        img: mokuai,
                        imgOn: mokuaiOn,
                        name: "保单查询",
                        type: false,
                    },
                    {
                        path: "/tel",
                        img: tel,
                        imgOn: telOn,
                        name: "客服热线",
                        type: false,
                    },
                    {
                        path: "/Ahome",
                        img: home,
                        imgOn: home,
                        name: "首页",
                        type: false,
                    },
                    {
                        path: "/wechat",
                        img: wechat,
                        imgOn: wechatOn,
                        name: "客服微信",
                        type: false,
                    },
                    {
                        path: "/qq",
                        img: qq,
                        imgOn: qqOn,
                        name: "客服QQ",
                        type: false,
                    },
                ],
                images:weixin
            }
        },
        props: {
        },
        created:function(){
            // 根据路径判断底部标签栏是否变色
            let pathNew =  this.$route.path
            for (var i = 0;i < this.tabberItem.length;i++){
                if(this.tabberItem[i].path == pathNew){
                    this.tabberItem[i].type = true
                }
            }
            // 当前窗口高度
            let winHeight = document.documentElement.clientHeight
        },
        methods: {

            // 跳转
            tabbarItem(path,index){
                var userAgentInfo = navigator.userAgent;
                var Agents = ["Android", "iPhone",
                    "SymbianOS", "Windows Phone",
                    "iPad", "iPod"];
                var flag = true;
                let pathNew =  this.$route.path
                if(path == "/Ahome" || path == "/AInsurancePolicy"){
                    if(!(path == pathNew)){
                        window.location.href = `${path}?type=0`
                    }
                }else if(path == "/tel"){
                    window.location.href = 'tel://' + this.tel
                }else if(path == "/wechat"){
                    this.images = weixin
                    this.hidden = 1
                }else if(path == "/qq"){
                    // let mob = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
                    // Notify({ type: 'primary', message: navigator.userAgent.match(mob)})
                    //window.clipboardData.setData('text',"aaaaaa")

                    for (var v = 0; v < Agents.length; v++) {
                        // if (userAgentInfo.indexOf(Agents[v]) > 0) {
                        //     flag = false;
                        //     Notify({ type: 'primary', message: '已复制qq号到剪切板'})
                        //     break;
                        // }else {
                            // PC端
                            Notify({ type: 'primary', message: '正在打开qq'})
                            location.href = "http://wpa.qq.com/msgrd?v=3&uin=3066619203&site=qq&menu=yes"
                        //}
                    }
                }
            },

            // 微信弹窗
            hiddenWechat(){
                this.hidden = 0
            }
        }
    }
</script>

<style scoped>
    .hover{
        color: rgb(6, 193, 174) !important;
        font-weight: bold;
    }
    #tabbar{
        width:100%;
        background-color:#fff;
        position: fixed;
        bottom: 0;
        z-index: 999;
        box-shadow: 0 0 10px 0 rgba(0,0,0,.2);
        display: flex;
    }
    #tabbar .tabbar-item{
        width:20%;
        color:#7b8196;
        height:3.2rem;
        text-align: center;
    }
    #tabbar a{
        display: block;
    }
    #tabbar .tabbar-item img{
        display: block;
        width:1.2rem;
        height:1.2rem;
        margin: 6px auto 0;
    }
    #tabbar .tabbar-item div{
        color: #7b8196;
        font-size: .6rem;
        line-height: 1.8rem;
    }
    #tabbar a:nth-child(3) .home-icon{
        width:3.5rem;
        /*line-height: 12vw;*/
        margin: auto;
    }
    #tabbar a:nth-child(3) .home-text{
        position: relative;
        bottom: 2rem;
    }
    #tabbar a:nth-child(3) .home-icon div{
        width: 3rem;
        height: 3rem;
        position: relative;
        bottom: 1.725rem;
        background-color: rgb(6, 193, 174);
        border: .25rem solid #fff;
        line-height: 3rem;
        border-radius: 50%;
    }
    #tabbar a:nth-child(3) .home-icon img{
        display: inline;
        margin-top: 14px;
    }

    /*微信弹窗*/
    .erweima{
        width: 60vw;
        min-height: 60vw;
        background-color: #fff;
        border-radius: 16px;
    }
    .erweima img{
        width:80%;
        margin-top: 10%;
        margin-left: 10%;
    }
    .wechat{
        width: 100vw;
        height: 100vh;
        background-color: rgba(0,0,0,.3);
        position:fixed;
        top: 0;
        left: 0;
    }
    .wechat div{
        width: 60vw;
        min-height: 60vw;
        background-color: #fff;
        margin: 30vh auto;
        border-radius: 16px;
    }
    .wechat div img{
        width:80%;
        margin-top: 10%;
        margin-left: 10%;
    }
</style>
